export function isMobile(vuetify) {
  return vuetify.breakpoint.mobile;
}

export function isTablet(vuetify) {
  return vuetify.breakpoint.smOnly;
}

export function isDesktop(vuetify) {
  return vuetify.breakpoint.mdAndUp;
}
